import { render, staticRenderFns } from "./giftCard.vue?vue&type=template&id=0de7beee&scoped=true&"
import script from "./giftCard.vue?vue&type=script&lang=js&"
export * from "./giftCard.vue?vue&type=script&lang=js&"
import style0 from "./giftCard.vue?vue&type=style&index=0&id=0de7beee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de7beee",
  null
  
)

export default component.exports